// Common constants for Kalyan Travels website
export const CONTACT_INFO = {
  PHONE: "9251110346",
  EMAIL: "info.kalyantravels@gmail.com",
  COMPANY_NAME: "Kalyan Travels"
};

export const WEBSITE_INFO = {
  TITLE: "Kalyan Travels - Rajasthan Tour Packages",
  DESCRIPTION: "Experience the royal heritage of Rajasthan with our exclusive tour packages",
  THEME_COLOR: "#d32f2f"
};

export const SOCIAL_LINKS = {
  FACEBOOK: "#",
  INSTAGRAM: "#",
  TWITTER: "#",
  YOUTUBE: "#"
};